import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { AgentsQueryKeys } from "./agentQueryKeys";
import { getAgents } from "@/api/agents";

export const useAgents = () => {
  return useQuery({
    queryKey: [AgentsQueryKeys.All],
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => {
      const params = {};
      return getAgents({ signal, params });
    },
  });
};
